import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleServiceClick = (serviceId: string) => {
    const element = document.getElementById(serviceId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1A2B4C] text-white relative overflow-hidden">
      {/* Декоративные элементы */}
      <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full border border-[#C5A880]/8 -translate-x-1/2 -translate-y-1/2 pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full border border-[#C5A880]/8 translate-x-1/3 translate-y-1/3 pointer-events-none" />

      {/* Верхняя золотая линия */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C5A880]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-12 mb-14">

          {/* Компания */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white font-['Playfair_Display'] leading-snug">
              Системный<br />Маркетинг
            </h3>
            <div className="w-8 h-px bg-[#C5A880] mb-5" />
            <p className="text-white/50 leading-relaxed mb-7 text-sm font-['Montserrat']">
              Превращаем хаос в систему. Объединяем экспертный опыт с точностью AI-алгоритмов для роста вашего бизнеса.
            </p>
            <div className="flex gap-3 mb-5">
              <a
                href="https://t.me/digital_AI_marketing"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#C5A880]/30 hover:border-[#C5A880] hover:bg-[#C5A880]/10 rounded-lg transition-all duration-300 cursor-pointer"
              >
                <i className="ri-telegram-line text-lg text-[#C5A880]" />
              </a>
              <a
                href="https://vk.com/sharovairinas"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#C5A880]/30 hover:border-[#C5A880] hover:bg-[#C5A880]/10 rounded-lg transition-all duration-300 cursor-pointer p-2"
              >
                <img src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/67a888ef3cc2b2235c0effc4b8ea0be2.png" alt="ВКонтакте" className="w-full h-full object-contain" />
              </a>
              <a
                href="https://tenchat.ru/IrinaSharova_marketing?utm_source=acc30d66-2a11-43a2-8f71-6799ce061e61"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-[#C5A880]/30 hover:border-[#C5A880] hover:bg-[#C5A880]/10 rounded-lg transition-all duration-300 cursor-pointer p-2"
              >
                <img src="https://static.readdy.ai/image/621f76ab0c5d0ae7827482fe9856efef/ceaec60262df5e2627173dae051e58c0.png" alt="TenChat" className="w-full h-full object-contain" />
              </a>
            </div>
            <div className="border-t border-[#C5A880]/15 pt-4 space-y-1">
              <p className="text-white/45 text-xs font-['Montserrat']">Шарова Ирина Сергеевна</p>
              <p className="text-white/35 text-xs font-['Montserrat']">Налоговый режим НПД</p>
              <p className="text-white/35 text-xs font-['Montserrat']">ИНН 344700440103</p>
            </div>
          </div>

          {/* Услуги */}
          <div>
            <h4 className="text-sm font-bold mb-5 text-[#C5A880] tracking-widest uppercase font-['Montserrat']">Услуги</h4>
            <ul className="space-y-3">
              {[
                { label: 'Цифровой Маркетинг 360°', id: 'service-digital-360' },
                { label: 'Комплексная стратегия', id: 'service-complex-strategy' },
                { label: 'Консалтинг по маркетингу', id: 'service-consulting' },
                { label: 'Стратегическое управление', id: 'service-partnership' },
                { label: 'Консалтинг маркетплейс Ozon', id: 'service-ozon' },
                { label: 'Контекстная реклама', id: 'service-standard' },
                { label: 'Таргетированная реклама', id: 'service-standard' },
                { label: 'SMM и Контент', id: 'service-standard' },
                { label: 'Создание сайтов', id: 'service-standard' },
              ].map((item, i) => (
                <li key={i}>
                  <button
                    onClick={() => handleServiceClick(item.id)}
                    className="text-white/50 hover:text-[#C5A880] transition-colors duration-200 cursor-pointer text-left text-sm font-['Montserrat'] flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-[#C5A880]/40 group-hover:bg-[#C5A880] transition-colors duration-200 flex-shrink-0" />
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Компания */}
          <div>
            <h4 className="text-sm font-bold mb-5 text-[#C5A880] tracking-widest uppercase font-['Montserrat']">Компания</h4>
            <ul className="space-y-3">
              {[
                { label: 'О нас', id: 'about' },
                { label: 'Кейсы', id: 'cases' },
                { label: 'Блог', id: '' },
              ].map((item, i) => (
                <li key={i}>
                  <button
                    onClick={() => item.id && handleServiceClick(item.id)}
                    className="text-white/50 hover:text-[#C5A880] transition-colors duration-200 cursor-pointer text-left text-sm font-['Montserrat'] flex items-center gap-2 group"
                  >
                    <span className="w-1 h-1 rounded-full bg-[#C5A880]/40 group-hover:bg-[#C5A880] transition-colors duration-200 flex-shrink-0" />
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>


          </div>


        </div>

        {/* Нижняя полоса */}
        <div className="border-t border-[#C5A880]/15 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/35 text-xs font-['Montserrat']">
              © {currentYear} Системный Маркетинг. Все права защищены.
            </p>
            <div className="flex flex-wrap gap-6 text-xs">
              <a href="#" className="text-white/35 hover:text-[#C5A880] transition-colors duration-200 cursor-pointer font-['Montserrat']">
                Политика конфиденциальности
              </a>
              <Link to="/oferta" className="text-white/35 hover:text-[#C5A880] transition-colors duration-200 cursor-pointer font-['Montserrat']">
                Публичная оферта
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
